var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('page-header',{attrs:{"title":"Новая таблица цен и весов"}}),_c('price-config-form',{attrs:{"model":_vm.model}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }